import styled, { css } from 'styled-components'

interface ZonesSliderButtonWrapperProps {
    direction: 'prev' | 'next'
}

export const ZonesSliderButtonWrapper = styled.button<ZonesSliderButtonWrapperProps>`
    position: absolute;
    top: 50%;
    right: 10px;
    z-index: 100;
    width: 32px;
    height: 32px;
    margin: 0;
    padding: 0;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    transform: translateY(-18px);

    ${({ direction }) =>
        direction === 'next'
            ? css`
                  right: 10px;
              `
            : css`
                  left: 10px;
              `};
`
